/**
 * Product Carousel.
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

import {
  EnumCarouselOptions,
  EnumScrollType,
  ProductCarouselAmountOptions,
  ProductCarouselScrollOptions,
  optionsToNum,
} from '@/src/pages/SalesChannelContentEditor/common';

import ProductDraggableDisplay from '@/src/constrains/ProductDraggableDisplay/ImgAndSkuShortDisplay';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import AutoPlay from '@/src/constrains/SalesChannelPreviewPageComponents/AutoPlay';
import { Select } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ProductCarousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,

    onItemDelete,

    onItemSort,
    onStaticChange,
    //To Do Delete Link Temp

    staticData,

    onItemDeleteAll,
    onItemReselect,
    products,
  } = props;

  const { scrollType, autoPlay, intervalTime, productToShow } = staticData;

  const _handleProductCarouselItemOnReselect = (products) => {
    onItemReselect(products);
  };

  const _handleProductCarouselItemOnDelete = (index) => {
    onItemDelete(index);
  };

  const _handleProductCarouselItemOnSort = (from, to) => {
    onItemSort(from, to);
  };

  const _handleProductCarouselItemOnDeleteAll = () => {
    onItemDeleteAll();
  };

  const handleOnScrollTypeChange = (data) => {
    if (onStaticChange) onStaticChange({ scrollType: data });
  };

  const handleOnIntervalChange = (data) => {
    if (onStaticChange) onStaticChange({ intervalTime: data });
  };

  const handleOnAutoPlayChange = (data) => {
    if (onStaticChange) onStaticChange({ autoPlay: data });
  };

  const handleOnProductToShowChange = (data) => {
    if (onStaticChange) onStaticChange({ productToShow: data });
  };

  const _showAuto = React.useMemo(() => {
    return scrollType === EnumScrollType.Paged;
  }, [scrollType]);

  const _tip = React.useMemo(() => {
    if (scrollType === EnumScrollType.Paged) {
      if (productToShow) {
        if (productToShow === EnumCarouselOptions.One) {
          return `${getI18n('general.carouselTipText')} 3`;
        } else {
          const number = optionsToNum[productToShow];
          return `${getI18n('general.carouselTipText')} ${number}`;
        }
      }
      return null;
    }
    if (scrollType === EnumScrollType.Smooth) {
      if (productToShow) {
        const number = optionsToNum[productToShow];
        return `${getI18n('general.carouselTipText2')} ${number + 1}`;
      }
      return null;
    }
    return null;
  }, [scrollType, productToShow]);

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('general.scrollType')}>
          <Select
            value={scrollType}
            onChange={handleOnScrollTypeChange}
            size='large'
            optionsList={ProductCarouselScrollOptions}
          />
        </ItemWrapper>
        {_showAuto && (
          <ItemWrapper>
            <AutoPlay
              interOnChange={handleOnIntervalChange}
              autoOnChange={handleOnAutoPlayChange}
              isAuto={autoPlay}
              interval={intervalTime}
            />
          </ItemWrapper>
        )}
        <ItemWrapper
          title={getI18n('general.productsToShow')}
          belowComponentTitle={_tip}>
          <Select
            value={productToShow}
            onChange={handleOnProductToShowChange}
            size='large'
            optionsList={ProductCarouselAmountOptions}
          />
        </ItemWrapper>
      </Section>
      <ProductDraggableDisplay
        onDeleteAll={_handleProductCarouselItemOnDeleteAll}
        onSort={_handleProductCarouselItemOnSort}
        onDelete={_handleProductCarouselItemOnDelete}
        onChange={_handleProductCarouselItemOnReselect}
        droppableId={droppableId || 'testDrop'}
        data={products}
      />
    </React.Fragment>
  );
};
export default ProductCarousel;
